import { NumberInput } from '~/components/ui/number-input'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type NumberFieldProps = React.ComponentProps<typeof NumberInput> &
  Omit<FieldProps, 'children' | 'error'>

export function NumberField({ label, id, optional, className, ...props }: NumberFieldProps) {
  // `number | undefined` : vider l'input propage `undefined` (clear) → la validation se déclenche.
  const field = useFieldContext<number | undefined>()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message

  return (
    <Field
      label={label}
      id={id}
      optional={optional}
      required={props.required}
      error={errorMessage}
      className={className}
    >
      <NumberInput
        {...props}
        className="w-full"
        id={field.name}
        name={field.name}
        onBlur={field.handleBlur}
        onValueChange={(v) => {
          // Clear (input vidé) : on propage undefined pour que la validation se déclenche au lieu
          // de conserver silencieusement l'ancienne valeur.
          field.handleChange(v === null ? undefined : v)
        }}
        aria-invalid={errorMessage !== undefined}
        value={field.state.value}
      />
    </Field>
  )
}
